import { modals as mantineModals } from "@mantine/modals";
import { ReactNode } from "react";
import ErrorBoundary from "../components/ErrorBoundary";

// ModalsProvider mounts outside the router tree (main.tsx), so a throw inside
// modal content unmounts the entire app. Import `modals` from this module
// instead of "@mantine/modals" to get content wrapped in an error boundary.
function withBoundary<T extends { children?: ReactNode }>(payload: T): T {
  if (!payload.children) return payload;
  return {
    ...payload,
    children: <ErrorBoundary>{payload.children}</ErrorBoundary>,
  };
}

export const modals: typeof mantineModals = {
  ...mantineModals,
  open: (payload) => mantineModals.open(withBoundary(payload)),
  openConfirmModal: (payload) =>
    mantineModals.openConfirmModal(withBoundary(payload)),
};
